// @flow
import { createCapHeader, createMeta } from "../../components/hocs/createCapHeader";
import { paramLink, titleSelector } from "../utils/page";

export const CapPairHeader = createCapHeader(titleSelector.pair, paramLink.capPairList);
export const CapPairMeta = createMeta(titleSelector.pair);
